import Dashelement from "components/Dashboard/Dashelement";
import React from "react";
import { useContext } from "react";
import { useState } from "react";
import MeetingReqView from "./MeetingReqView";
import { Calendar, globalizeLocalizer } from "react-big-calendar";
import moment from "moment";
import globalize from "globalize";
import "react-big-calendar/lib/css/react-big-calendar.css";
import "./mymeeting.css";
import DemoContext from "context/DemoContext";
import { OverlayTrigger, Popover, Toast } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import RescheduleModal from "components/Modal/RescheduleModal";
import { useRef } from "react";
import VideoContext from "context/VideoContext";
import AuthContext from "context/AuthContext";
import { useEffectOnce } from "hooks/useEffectOnce";
import {
  calculateDifferenceToday,
  convertUTCToLocal,
  getScheduleTimeDifference,
} from "utils/dateFormatter";
import { Google } from "react-bootstrap-icons";
import VideoPlayerModal from "components/Modal/VideoPlayerModal";
import RequestDot from "components/RequestDot/RequestDot";
import { Button, Modal, Checkbox, Card, Input, message } from "antd";
import { CopyOutlined } from '@ant-design/icons';
import DotsContext from "context/DotsContext";
import { getAllProductsForHost, getAllStoresForHost } from "Services/storeService";
import LiveMeeting from "./LiveMeeting";
import DataContext from "context/DataContext";
import { SUCCESS_MESSAGES, canHostRescheduleDemo } from "./constants";
import useCan from "hooks/useCan";
import { ROLES } from "utils/constants";
const localizer = globalizeLocalizer(globalize);

const MyMeetings = ({
  demoRequests,
  calendarData,
  acceptedOtherData,
  scheduledMyData,        
  scheduledAllData,       
  scheduledOthersData,
  handleNavigate,
}) => {
  let { user } = useContext(AuthContext);
  const { setStoreList, setSalesStoreList } = useContext(DotsContext);
  const { allHostProducts, setAllHostProducts } = useContext(DataContext);
  const [storesLoading, setStoresLoading] = useState(true);
  const [activeTab, setActiveTab] = useState("all");

 /**
  * This function is used to get all the stores in order to connect with them for a host
  *
  * @return {void}
  */

 const getAllStores = async () => {
  try {
    const storesList = await getAllStoresForHost();
    setStoresLoading(false);
    setStoreList(storesList?.data?.data);
    setSalesStoreList(storesList?.data?.sales_person_data)
  } catch (err) {
    console.log(err);
  }
};

 /**
  * This function is used to get all the products of a host
  *
  * @return {void}
  */

 const getAllProductsOfHost = async () => {
  try {
    const products = await getAllProductsForHost();
    setAllHostProducts(products?.data);
  } catch (err) {
    console.log(err);
  }
};

  useEffectOnce(() => {
    if (user.role === ROLES.HOST.role) {
      getAllStores();
      getAllProductsOfHost();
    }
  }, []);

  const eventList = [];
  if (calendarData?.length > 0) {
    calendarData?.map((x, i) => {
      if (!x?.schedule?.scheduled_date || !x?.schedule?.scheduled_time) return null;
      var [utcDate, utcTime] = convertUTCToLocal(
        x?.schedule.scheduled_date + "T" + x?.schedule?.scheduled_time
      );
      return eventList.push({
        start: new Date(utcDate + "T" + utcTime),
        end: new Date(moment(utcDate + "T" + utcTime).add(30, "minutes")),
        title: x.product && x.product.name,
        time: utcTime,
        myCust: x,
        isOwnDemo: x?.host_id === user?.uid,
      });
    });
  }

  const getDemoRequest = () => {
    if (demoRequests.length < 1) {
      return <div>No Video Meeting request available</div>;
    } else {
      return demoRequests.map((demoRequest, index) => {
        return (
          <MeetingReqView
            key={index}
            demoDetail={demoRequest}
            event={eventList}
            storesLoading={storesLoading}
            customClass="my-meeting-page"
          />
        );
      });
    }
  };

  const scheduledDataMap = {
    all: scheduledAllData || [],
    yours: scheduledMyData || [],
    others: scheduledOthersData || [],
  };

  const getCardColorClass = (item) => {
    if (activeTab === "yours") return "scheduled-card--blue";
    if (activeTab === "others") return "scheduled-card--purple";
    if (activeTab === "all") {
      return item?.host_id === user?.uid
        ? "scheduled-card--blue"
        : "scheduled-card--purple";
    }
  };

  const getScheduledCards = () => {
    let data = scheduledDataMap[activeTab];
    if (!data || data.length === 0) {
      return <p className="scheduled-empty">No meetings found.</p>;
    }

    data = data.filter((item) => {
      if (!item?.scheduled_date || !item?.scheduled_time) return false;
      const scheduledDateTime = new Date(`${item.scheduled_date}T${item.scheduled_time}Z`);
      return scheduledDateTime > new Date();
    });
    if (data.length === 0) {
      return <p className="scheduled-empty">No upcoming meetings.</p>;
    }

    return data.map((item, i) => (
      <div
        key={i}
        className={`request-component my-meeting-page scheduled-card ${getCardColorClass(item)}`}
      >
        <p className="detail_desc_name">
          <span className="letter_title_desc">Store: </span>
          {item?.store_name}
        </p>
        <p className="detail_desc_name">
          <span className="letter_title_desc">Guest: </span>
          {item?.members?.guest_detail?.full_name?.toUpperCase()}
        </p>

        <p className="detail_desc_name">
          <span className="letter_title_desc">Host: </span>
          {item?.host_name?.toUpperCase()}
        </p>

        <p className="detail_desc_name">
          <span className="letter_title_desc">Meeting begins in: </span>
          {getScheduleTimeDifference(
            `${item?.scheduled_date}T${item?.scheduled_time}Z`
          )}
        </p>
      </div>
    ));
  };

  return (
    <>
      <div className="row row-meeting-wrapper">
        <div className="col-lg-9 col-md-12 col-sm-12 meeting-wrapper">
          <Dashelement className="features meeting-wrapper meeting-features" >
            {
              user?.role === ROLES.HOST.role && (
                <LiveMeeting products={allHostProducts}/>
              )
            }
            <Calendar
              className="custom"
              localizer={localizer}
              defaultDate={new Date()}
              defaultView="month"
              events={eventList}
              style={{ height: "80vh", width: "100%" }}
              components={{
                event: Event,
              }}
              onNavigate={handleNavigate}
            />
          </Dashelement>
        </div>
        <div className="col-lg-3 col-md-12 col-sm-12">
          <Dashelement className="features demo-request-wrapper">
            <h5 className="text-center mt-3">
              Video Meeting Requests
              {demoRequests.length > 0 && <RequestDot />}
            </h5>
            <div className="demo_request_wrapper_main">
              <div className="request_wrapper_custom">{getDemoRequest()}</div>
            </div>
            {user.role === ROLES.HOST.role && (
              <>
                <div className="request-title-wrapper">
                  <h5 className="text-center my-3">Scheduled</h5>
                </div>
                <div className="scheduled-tab-bar">
                  {["all", "yours", "others"].map((tab) => (
                    <button
                      key={tab}
                      className={`scheduled-tab scheduled-tab--${tab} ${activeTab === tab ? "scheduled-tab--active" : ""}`}
                      onClick={() => setActiveTab(tab)}
                    >
                      {tab.charAt(0).toUpperCase() + tab.slice(1)}
                    </button>
                  ))}
                </div>
                <div className="scheduled_wrapper">{getScheduledCards()}</div>
              </>
            )}
          </Dashelement>
        </div>
      </div>
    </>
  );
};

export default MyMeetings;

const Event = ({ event }) => {
  let { user } = useContext(AuthContext);
  const { isStoreUser } = useCan();
  let { hostCancelAccepted, userDemos, userAcceptedDemos } =
    useContext(DemoContext);
  let { setDemoId } = useContext(VideoContext);
  const [showA, setShowA] = useState(false);
  const [show, setShow] = useState(false);
  const [enabled, setEnabled] = useState(true);
  const [watchMeeting, setWatchMeeting] = useState(null);
  const [showVideoModal, setShowVideoModal] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showStartedModal, setStartedShowModal] = useState(false);
  const [isChecked, setIsChecked] = useState(false);


  /**
   * This function is used to copy the live meeting URL
   *
   * @return {void}
   */
    const handleCopy = (url) => {
      navigator.clipboard.writeText(url);
      message.success(SUCCESS_MESSAGES.COPY_TO_CLIPBOARD);
    };

    /**
   * This function is a for checkbox 
   *
   * @param {e} event for checkbox
   * @return {void}
   */
  const handleCheckboxChange = (e) => {
    setIsChecked(e.target.checked);
    e.stopPropagation();
  };
  const handleShowRecording = () => {
    let modalToClose = document.getElementById("popover-trigger-click-close");
    modalToClose.hidden = true;
    setShowVideoModal(true);
  };
  const handleCloseRecording = () => setShowVideoModal(false);
  const handleClose = () => setShow(false);
  const navigate = useNavigate();
  let overlayRef = useRef(null);
  const handleShow = () => {
    overlayRef?.current?.click();
    setShow(true);
  };
  const scheduledDate = event.myCust?.schedule?.scheduled_date;
  const scheduledTime = event.myCust?.schedule?.scheduled_time;

  const [utcDate, utcTime] = scheduledDate && scheduledTime
    ? convertUTCToLocal(scheduledDate + "T" + scheduledTime)
    : [null, null];
  const a = calculateDifferenceToday(utcDate + " " + utcTime, "minutes");
  const calendarDate = moment(utcDate + " " + utcTime).format(
    "YYYYMMDDTHHmmss"
  );
  const utcTimeAMPM = moment(calendarDate).format("YYYY-MM-DD, hh:mm A");
  const created_atAMPM = moment(event?.myCust?.created_at).format(
    "YYYY-MM-DD, hh:mm A"
  );
  const started_atAMPM = moment(event?.myCust?.started_at).format(
    "YYYY-MM-DD, hh:mm A"
  );
  const calendarDateend = moment(calendarDate)
    .add(30, "minutes")
    .format("YYYYMMDDTHHmmss");

  const viewMeetingRecordings = () => {
    let response = fetch(event?.myCust?.recorded_video?.cloudinary_file);
    response
      .then(function (res) {
        if (res && res.status === 200) {
          setWatchMeeting(res?.url);
        } else {
          setWatchMeeting(event?.myCust?.recorded_video?.recorded_video);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  /**
   * This function is a cancel function for closing the modal window
   *
   * @param {void}
   * @return {void}
   */
  const handleCancelJoin = () => {
    const modalToClose = document.getElementById("popover-trigger-click-close");
    modalToClose.hidden = true;
    setIsChecked(false);
    setShowModal(false);
  };

  /**
   * This function is a cancel function for closing the modal window
   *
   * @param {void}
   * @return {void}
   */

  const handleCancelStartedJoin = () => {
    const modalToClose = document.getElementById("popover-trigger-click-close");
    modalToClose.hidden = true;
    setIsChecked(false);
    setStartedShowModal(false);
  };

  /**
   * This function is used to navigate to the waiting room when the call is already being started by the host
   *
   * @return {void}
   */

  const handleStartedJoinCall = () => {
    setEnabled(false);
    setDemoId(event.myCust.id);
    localStorage.setItem("demoId", event.myCust.id);
    navigate(`/demo/waiting-room/${event.myCust.id}`, {
      state: {
        eventDetail: event.myCust,
        direct: "yes",
      },
    });
    setEnabled(true);
  };

  /**
   * This function is used to navigate to the waiting room when the host joins the call
   *
   * @return {void}
   */

  const handleJoinCall = () => {
    setEnabled(false);
    setDemoId(event.myCust.id);
    localStorage.setItem("demoId", event.myCust.id);
    navigate(`/demo/waiting-room/${event.myCust.id}`);
    setEnabled(true);
  };

  useEffectOnce(() => {
    viewMeetingRecordings();
  }, []);

  /**
   * Returns whether the given user role may see extended calendar popover details
   * and own-demo actions (the host, or any store-side user).
   *
   * Store-side membership comes from `isStoreUser` (capabilities), not a role list.
   *
   * @param {number} role - Application user role id.
   * @returns {boolean} True if the role is the host or holds a store capability.
   */
  const isElevatedRole = (role) => {
    return role === ROLES.HOST.role || isStoreUser;
  };

  /**
   * Renders the Ant Design Terms and Conditions modal used before joining a video meeting.
   * Join is disabled until the checkbox is checked; uses component `isChecked` state.
   *
   * @param {boolean} open - Whether the modal is visible.
   * @param {() => void} onOk - Handler when user confirms join (and modal primary action).
   * @param {() => void} onCancel - Handler when user dismisses the modal or mask-clicks.
   * @returns {import('react').ReactElement} The configured Modal with checkbox footer.
   */
  const renderJoinMeetingModal = (open, onOk, onCancel) => {
    return (
      <Modal
        title="Terms and Conditions"
        open={open}
        onOk={onOk}
        onCancel={onCancel}
        maskClosable={onCancel}
        footer={[
          <Button key="cancel" onClick={onCancel}>Cancel</Button>,
          <Button key="join" type="primary" onClick={onOk} disabled={!isChecked}>Join</Button>,
        ]}
      >
        <Checkbox onChange={handleCheckboxChange}>
          I accept the{" "}
          <button onClick={() => navigate("/user/settings?page=term")} className="link-button">
            Terms and Conditions
          </button>.
        </Checkbox>
      </Modal>
    );
  };

  /**
   * Hides the calendar event popover (by id) and opens the given modal setter.
   * Prevents the popover from staying visible behind the Ant Design modal.
   *
   * @param {(open: boolean) => void} modalSetter - State setter (e.g. `setShowModal`) called with `true`.
   * @returns {void}
   */
  const openPopoverModal = (modalSetter) => {
    const modalToClose = document.getElementById("popover-trigger-click-close");
    modalToClose.hidden = true;
    modalSetter(true);
  };

  /**
   * Popover body for meetings whose scheduled time is well past the window (`a < -9`).
   * Branches on host vs staff role, demo ownership, status (ACCEPTED, STARTED, ENDED),
   * live meeting grace window, and guest attendance for recording / missed copy.
   *
   * @returns {import('react').ReactElement} Fragment or elements for the expired-meeting section.
   */
  const renderExpiredMeetingContent = () => {
    const status = event?.myCust?.status;
    const guestAttended = event?.myCust?.members?.guest_detail?.attend_meeting;
    const hasRecordingUrl =
      event?.myCust?.recorded_video?.cloudinary_file !== null ||
      event?.myCust?.recorded_video?.recorded_video !== null;

    if (user.role === ROLES.HOST.role && status === "ACCEPTED" && event.isOwnDemo) {
      if (event?.myCust?.is_live_meeting && a > -59) {
        return (
          <>
            <button
              onClick={() => openPopoverModal(setShowModal)}
              className="btn btn-primary"
            >
              Join Video Meeting
            </button>
            {renderJoinMeetingModal(showModal, handleJoinCall, handleCancelJoin)}
          </>
        );
      } else {
        return (
          <>
            Meeting Expired!
            <p>{canHostRescheduleDemo(event?.myCust) ? 'Reschedule or Cancel' : 'Cancel'}</p>
          </>
        );
      }
    } else if (user.role === ROLES.HOST.role && status === "STARTED" && event.isOwnDemo) {
      return (
        <>
          <button
            onClick={() => openPopoverModal(setStartedShowModal)}
            className="btn btn-primary"
            disabled={utcDate < new Date().toISOString().split("T")[0]}
          >
            Join Video Meeting
          </button>
          {renderJoinMeetingModal(showStartedModal, handleStartedJoinCall, handleCancelStartedJoin)}
        </>
      );
    } else if (user.role === ROLES.HOST.role && status === "ENDED" && event.isOwnDemo) {
      if (guestAttended) {
        return (
          <>
            <div className="meeting-link">
              <button
                className="btn btn-primary btn-sm-primary btn-paid"
                onClick={handleShowRecording}
              >
                Watch Recording
              </button>
              <VideoPlayerModal
                show={showVideoModal}
                handleClose={handleCloseRecording}
                recordingUrl={hasRecordingUrl ? watchMeeting : null}
              />
            </div>
            <p>Meeting Concluded</p>
          </>
        );
      } else {
        return <>Meeting Missed (Guest)</>;
      };
    } else if (isStoreUser && status === "ACCEPTED") {
      return <>Meeting Missed (Host)</>;
    } else if (isStoreUser && status === "ENDED") {
      if (guestAttended) {
        return (
          <>
            <div className="meeting-link">
              <button
                className="btn btn-primary btn-sm-primary btn-paid"
                onClick={handleShowRecording}
              >
                Watch Recording
              </button>
              <VideoPlayerModal
                show={showVideoModal}
                handleClose={handleCloseRecording}
                recordingUrl={hasRecordingUrl ? watchMeeting : null}
              />
            </div>
            <p>Meeting Concluded</p>
          </>
        );
      } else {
        return <>Meeting Missed (Guest)</>;
      }
    } else {
      if (user?.role === ROLES.HOST.role && !event?.isOwnDemo) {
        return <></>;  
      } else {
        return <p>Hasn't happened yet</p>;
      }
    }
  };

  /**
   * Renders time-relative UI for an own-demo calendar event: join window, add-to-calendar,
   * or expired block. Uses `a` (minutes from now to scheduled start) and `user.role`.
   *
   * @returns {import('react').ReactElement|null} Join/calendar/expired content, or null when no branch applies.
   */
  const renderTimingBlock = () => {
    const hasRecordingUrl =
      event?.myCust?.recorded_video?.cloudinary_file !== null ||
      event?.myCust?.recorded_video?.recorded_video !== null;
    if (a <= 4 && a >= -9) {
      return (
        <>
          {user.role === ROLES.HOST.role && event.isOwnDemo && event?.myCust?.status !== "ENDED" ? (
            <button
              onClick={() => openPopoverModal(setShowModal)}
              className="btn btn-primary"
            >
              Join Video Meeting
            </button>
          ) : event?.myCust?.status === "ENDED" ? (
            event?.isOwnDemo ? (
            <>
              <div className="meeting-link">
                <button
                  className="btn btn-primary btn-sm-primary btn-paid"
                  onClick={handleShowRecording}
                >
                  Watch Recording
                </button>
                <VideoPlayerModal
                  show={showVideoModal}
                  handleClose={handleCloseRecording}
                  recordingUrl={hasRecordingUrl ? watchMeeting : null}
                />
              </div>
              <p>Meeting Concluded</p>
            </>
            ) : (
              <p>Meeting Concluded</p>
            )
          ) : (
            <p>Meeting in Progress</p>
          )}
          {renderJoinMeetingModal(showModal, handleJoinCall, handleCancelJoin)}
        </>
      );
    } else if (a >= 4) {
      if (user.role === ROLES.HOST.role && event.isOwnDemo) {
        return (
          <a
            rel="noreferrer"
            target="_blank"
            href={`https://calendar.google.com/calendar/render?action=TEMPLATE&dates=${calendarDate}%2F${calendarDateend}&text=${event.myCust?.product_name}%20Demo`}
            title="Save Event in my Calendar"
            className="add_to_calendar_wrapper"
          >
            Add to Calendar <Google />
          </a>
        );
      }
      return null;
    } else if (a < -9) {
      return (
        <div className="expired_meeting_date">
          {renderExpiredMeetingContent()}
        </div>
      );
    }
    return null;
  };

  /**
   * Renders guest-facing metadata in the popover (real customer, product, request/accepted times)
   * for users with an elevated role. Returns nothing for other roles.
   *
   * @returns {import('react').ReactElement|null} Detail block or null if role is not elevated.
   */
  const renderMeetingDetails = () => {
    if (!isElevatedRole(user.role)) {
      return null;
    }

    return (
      <>
        <p className="user-name">
          Real Customer &nbsp;: {event?.myCust?.members?.host_detail?.first_name}{" "}
          {event?.myCust?.members?.host_detail?.last_name?.charAt(0)}.
        </p>
        <h5>{event?.myCust?.product?.name}</h5>
        <p>
          Video Meeting Request (
          {event.myCust.soonest_at ? "Soonest At" : "Date Picked"}) :
          <br />
          <span>{created_atAMPM}</span>
        </p>
        <p>
          Accepted at: <br />
          <span>{utcTimeAMPM}</span>
        </p>
        {event.myCust.started_at && (
          <p>
            Started at: <br />
            <span>{started_atAMPM}</span>
          </p>
        )}
      </>
    );
  };

  /**
   * Renders calendar popover actions for elevated roles (host or store-side): timing block, then host-only
   * live URL and cancel/reschedule when `event.isOwnDemo`, plus the cancel-failure toast.
   *
   * @returns {import('react').ReactElement|null} Actions and toast wrapper, or null if role is not elevated.
   */
  const renderOwnDemoActions = () => {
    if (!isElevatedRole(user.role)) {
      return null;
    }

    return (
      <>
        {renderTimingBlock()}
        {user.role === ROLES.HOST.role && event?.myCust?.is_live_meeting && event?.isOwnDemo && (
          <Card className="live-meeting-card">
            <p>Live meeting URL for the guest:</p>
            <Input
              value={`${process.env.REACT_APP_URL}/live-meeting/${event?.myCust?.id}`}
              readOnly
              addonAfter={
                <CopyOutlined
                  onClick={() =>
                    handleCopy(`${process.env.REACT_APP_URL}/live-meeting/${event?.myCust?.id}`)
                  }
                />
              }
            />
          </Card>
        )}
        {user.role === ROLES.HOST.role && event?.isOwnDemo && (
          <div className="button-wrapper d-flex">
            <button
              disabled={!enabled || utcDate < new Date().toISOString().split("T")[0]}
              className="btn"
              onClick={() => {
                const response = hostCancelAccepted(event.myCust.id);
                response
                  .then(function (response) {
                    if (response.status === 200) {
                      userDemos();
                      userAcceptedDemos();
                    }
                  })
                  .catch(function (error) {
                    userDemos();
                    userAcceptedDemos();
                    setShowA(!showA);
                  });
              }}
            >
              Cancel
            </button>
            {canHostRescheduleDemo(event?.myCust) && (
              <button
                className="btn"
                disabled={utcDate < new Date().toISOString().split("T")[0]}
                onClick={handleShow}
              >
                Reschedule
              </button>
            )}
          </div>
        )}
        <Toast show={showA} onClose={() => setShowA(!showA)}>
          <Toast.Header>
            <strong className="me-auto">Failed!</strong>
          </Toast.Header>
          <Toast.Body>This Video Meeting couldn't be canceled.</Toast.Body>
        </Toast>
      </>
    );
  };

  /**
   * Full inner content of the calendar event popover: guest line, optional meeting details,
   * and own-demo / role-specific actions.
   *
   * @returns {import('react').ReactElement} Fragment containing all popover sections.
   */
  const renderPopoverContent = () => {
    return (
      <>
        <p className="user-name">
          Guest: {event?.myCust?.members?.guest_detail?.full_name}
        </p>
        {renderMeetingDetails()}
        {renderOwnDemoActions()}
      </>
    );
  };

  let popoverClickRootClose = (
    <Popover id="popover-trigger-click-close">
      {renderPopoverContent()}
    </Popover>
  );
  return (
    <div>
      <div>
        <OverlayTrigger
          id="help"
          trigger={"click"}
          rootClose
          placement="top"
          overlay={popoverClickRootClose}
        >
          <div ref={overlayRef}>{event.title}</div>
        </OverlayTrigger>
        <RescheduleModal
          showStatus={show}
          clickStatus={handleClose}
          title={event?.myCust?.members?.guest_detail?.first_name}
          eventDetail={event.myCust}
        />
      </div>
    </div>
  );
};
